import { getGenericResultErrorCodes } from "./passwordResetErrors";

const INVALID_TOKEN_CODE = "GNR-00040";
const EXPIRED_TOKEN_CODE = "GNR-00041";

export const isEmailVerificationTokenInvalid = (errorOrResult) =>
  getGenericResultErrorCodes(errorOrResult).includes(INVALID_TOKEN_CODE);

export const isEmailVerificationTokenExpired = (errorOrResult) =>
  getGenericResultErrorCodes(errorOrResult).includes(EXPIRED_TOKEN_CODE);
